import LoadingOverlay from "../../components/LoadingOverlay";

export default function DictionaryResult({
  html, 
  error,
  loading,
  mealPlanHtml, 
  onMealPlan, 
  mealPlanLoading,
  mealPlanError,
  showMealPlanButton = true,
}) {
  return (
    <div className="dictionary-result">
      {loading ? (
        <LoadingOverlay visible={loading} />
      ) : error ? (
        <p className="error">{error}</p>
      ) : html ? (
        <div className="answer">
          <div dangerouslySetInnerHTML={{ __html: html }} />
        </div>
      ) : (
        <p></p>
      )}

      {/* 보조 기능: 식단 추천 */}
      {!!html && showMealPlanButton && (
        <div className="dictionary-feature">
          <button className="btn" onClick={onMealPlan} disabled={mealPlanLoading}>
            하루 식단 추천 받기
          </button>

          <LoadingOverlay visible={mealPlanLoading} />
          {mealPlanError && <p className="error">{mealPlanError}</p>}
          {mealPlanHtml && <div className="mealplan-result" dangerouslySetInnerHTML={{ __html: mealPlanHtml }} />}
        </div>
      )}
    </div>
  );
}
